import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import imgVerifyCode from '@/components/imgVerifyCode'
export default {
name: 'logoutVerify',
directives: {
TransferDom
},
components: {
imgVerifyCode,
Confirm,
Icon
},
data () {
return {
identifyCodes: "abcdefghijklnmopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
identifyCode: "",
myInfo: {},
phoneStep: {
imgverifyCode: '',
verificationCode: '',
timerText: '',
isGetCode: true,
},
showLogoutConfirm: false,
showLogoutSuccess: false,
showCancelLogoutConfirm: false,
stepPlan: '',
canNotPassReason: '',
}
},
methods: {
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   
console.log(d)
},

randomNum(min, max) {
return Math.floor(Math.random() * (max - min) + min);
},
refreshCode() {
this.identifyCode = "";
this.makeCode(this.identifyCodes, 4);
},
makeCode(o, l) {
for (let i = 0; i < l; i++) {
this.identifyCode += this.identifyCodes[
this.randomNum(0, this.identifyCodes.length)
];
}
},
getStepPlan () {
this.$request.post('/user/selectLogoutExamine',{

}).then(data => {
if(data.code == 0){
if(!data.obj){

this.showCancelLogoutConfirm = true
}else if(data.obj.doneStatus == '0' && data.obj.auditStatus == '0'){
this.stepPlan = '1'
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '0'){
this.stepPlan = '2'
this.canNotPassReason = data.obj.refuseMsg
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '1'){
this.stepPlan = '3'
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getMyInfo () {
this.$request.post('/user/getMyOrderInfo',{

}).then(data => {
if(data.code == 0){
this.myInfo = {...data.obj}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getCode () {   //获取验证码的函数
this.phoneStep.isGetCode = false
let codeTimer = 60
this.phoneStep.timerText = codeTimer-- + 'S'
let timeOutFn = setInterval(() => {
this.phoneStep.timerText = codeTimer-- + 'S'
if(codeTimer == -1){
codeTimer = 60
clearInterval(timeOutFn)
this.phoneStep.isGetCode = true
}
}, 1000);
this.$request.post('/message/verificationCode',{
phone: this.myInfo.phone
}).then(data => {
console.log(data)
}).catch(e => {
console.log(e)
})
},
confirmLogout () {
console.log(this.identifyCode);
console.log(this.phoneStep.imgverifyCode);







if(this.identifyCode.toLocaleUpperCase() != this.phoneStep.imgverifyCode.toLocaleUpperCase()){
this.$vux.toast.show({
type: 'warn',
text: '图片验证码错误'
})
return false;
}

this.$request.post('/message/verificationCodeByCode',{
phone: this.myInfo.phone,
verificationCode: this.phoneStep.verificationCode
}).then(data => {
if(data.code == 0){
this.showLogoutConfirm = true
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
},
onConfirmLogout () {
console.log(111)
this.$request.post('/user/logoutUser',{

}).then(data => {
if(data.code == 0){
QC.Login.signOut()
this.setCookie('_token', "", -1)
this.setCookie('_isMonthlyKnots', "", -1)

this.$token = null
this.showLogoutSuccess = true
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
},
cancelLogout () { //取消注销
this.$request.post('/user/delLogoutExamine',{

}).then(data => {
if(data.code == 0){
this.getStepPlan()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
onConfirmCancelLogout () {
this.$router.push({
path: '/personalData'
})
},
backPersonalData () {
this.$request.post('/user/delLogoutExamine',{

}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/personalData'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
nexStepLogout () {
this.stepPlan = '4'
},
onConfirmLogoutSuccess () {
this.stepPlan = '5'
},
backHomePage () {
this.$router.push({
path: '/'
})
}
},
created () {

},
mounted() {

this.makeCode(this.identifyCodes, 4);
this.getStepPlan()
this.getMyInfo()
}
}



// WEBPACK FOOTER //
// ./src/views/logoutVerify/script.js